import FormFieldViewText from "components/FormFields/ViewText";
import FormField from "ds/components/Form/Field";
import SecretFieldDetails from "ds/components/SecretFieldDetails";
import { GitlabIntegration } from "types/generated";

import { REGENERATE_GITLAB_INTEGRATION_WEBHOOK_SECRET } from "../../gql";
import { useRefreshSecret } from "../../useRefreshSecret";
import { VCSCheckLabels } from "./helpers";
import VCSIntegrationsUseGitCheckoutInfo from "./UseGitCheckoutInfo";

type VCSIntegrationsDetailsGitLabProps = {
  details: GitlabIntegration;
  canEdit?: boolean;
};

const VCSIntegrationsDetailsGitLab = ({ details, canEdit }: VCSIntegrationsDetailsGitLabProps) => {
  const [webhookSecret, regenerateSecret] = useRefreshSecret(
    details.id,
    details.webhookSecret,
    REGENERATE_GITLAB_INTEGRATION_WEBHOOK_SECRET,
    (data) => data.gitlabIntegrationRegenerateWebhookSecret.webhookSecret
  );

  return (
    <>
      <FormFieldViewText label="API host URL" value={details.apiHost} />

      <FormFieldViewText label="User facing host URL" value={details.userFacingHost} />

      <FormField label="Webhook secret">
        <SecretFieldDetails
          secret={webhookSecret}
          regenerateSecret={canEdit ? regenerateSecret : undefined}
        />
      </FormField>

      <FormFieldViewText
        label="Webhook endpoint"
        value={details.webhookUrl}
        withCopy
        noTextEllipsis
        textWordBreak
      />
      <VCSIntegrationsUseGitCheckoutInfo value={details.useGitCheckout} />
      <FormFieldViewText label="VCS checks" value={VCSCheckLabels[details.vcsChecks]} />
    </>
  );
};

export default VCSIntegrationsDetailsGitLab;
